import { differenceInMinutes, isAfter, isBefore } from 'date-fns';
import { GanttConfig } from '../GanttConfig';
import { useEffect, useLayoutEffect, useState } from 'react';

export const useTimeMarker = (startDate: Date, endDate: Date, measureScale: number) => {
  const [isTimeMarkerVisible, setIsTimeMarkerVisible] = useState(() => {
    const now = new Date();
    return isAfter(now, startDate) && isBefore(now, endDate);
  });

  const [timeMarkerDistance, setTimeMarkerDistance] = useState(0);

  useLayoutEffect(() => {
    const updateTimeMarkerDistance = () => {
      const currentTime = new Date();
      const minutesDifference = differenceInMinutes(currentTime, startDate);
      const hourDifference = minutesDifference / 60;
      const scaleFactor = GanttConfig.SINGLE_ELEMENT_WIDTH / measureScale;
      // add single element offset to display full element eg. one day
      const distance = hourDifference * scaleFactor;
      setTimeMarkerDistance(distance);
    };
    updateTimeMarkerDistance();
    const timeMarkerInterval = setInterval(updateTimeMarkerDistance, GanttConfig.TIME_MAKER_TIMEOUT);
    return () => {
      clearInterval(timeMarkerInterval);
    };
  }, [measureScale, startDate]);

  useEffect(() => {
    const now = new Date();
    setIsTimeMarkerVisible(isAfter(now, startDate) && isBefore(now, endDate));
  }, [endDate, startDate]);

  return { isTimeMarkerVisible, timeMarkerDistance };
};
